// extracted by mini-css-extract-plugin
export default {"root":"root--sp46h","blend":"blend--tO1Ij"};